module.exports = __webpack_public_path__ + "static/media/pencil.a14eeeb1.svg";